/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';

export const WebItemButton = styled(Button)`
  margin-right: ${gridSize()}px;
  &:last-child {
    margin-right: 0;
  }
`;
